module.exports = __webpack_public_path__ + "static/media/4.9e30185f.jpg";